import { FC, InputHTMLAttributes } from 'react';

import './checkbox.scss';

interface IProps {
    id?: string;
    label: string;
}

type Props = IProps & InputHTMLAttributes<HTMLInputElement>;

export const Checkbox: FC<Props> = ({ id, label, ...props }) => {
    const attrId = id || `checkbox_${label}`;

    return (
        <div className="form-group">
            <input type="checkbox" id={attrId} name={`checkbox_${label}`} {...props} />
            <label htmlFor={attrId}>{label}</label>
        </div>
    );
};
